import { apiFriendshipGetAndSend } from '@/api/imee.js'

export default {
  data () {
    return {
      isRequesting: false,
      laterShowNewfriendship: false,
      showNewfriendship: false,
      showSendGift: false,
      waitSendObj: null,
      guideShow: false,
      targetLoc: {
        w: 80,
        h: 75,
        l: 100
      }
    }
  },
  methods: {
    locationTarget (targetId, afterFn) {
      let viewH = document.body.clientHeight

      if (targetId) {
        let targetNode = document.getElementById(targetId)
        let targetPos = null
        if (targetNode) {
          targetPos = targetNode.getBoundingClientRect()
        }
        if (targetPos) {
          // 已在视口
          if (targetPos.bottom <= viewH) {
            // 在合适位置
            if (viewH - targetPos.bottom >= 100) {
              afterFn && afterFn()
            }
            // 不在合适位置
            else {
              document.body.scrollTo({ top: 100 - (viewH - targetPos.bottom) })
              setTimeout(() => {
                afterFn && afterFn()
              }, 20)
            }
          }
          // 不在视口
          else {
            document.body.scrollTo({ top: targetPos.bottom - viewH + 100 })
            setTimeout(() => {
              afterFn && afterFn()
            }, 20)
          }
        }
      }
    },
    calculatePos (targetId) {
      if (targetId) {
        let targetNode = document.getElementById(targetId)
        let targetPos = null
        if (targetNode) {
          targetPos = targetNode.getBoundingClientRect()
        }
        if (targetPos) {
          this.targetLoc.w = targetPos.width
          this.targetLoc.h = targetPos.height + 20
          this.targetLoc.l = targetPos.left
          this.targetLoc.b = document.body.clientHeight - targetPos.bottom - 10

          this.guideShow = true
        }
      }
    },
    handleGet (item, index, imgType) {
      // 未达到
      if (item.grade > this.data.grade) {
        return
      }
      // 已领过
      if (item.children && item.children[index] && item.children[index].ifTakeReward) {
        return
      }
      if (item.children && item.children[index]) {
        this.waitSendObj = {
          grade: item.grade,
          ...item.children[index],
          imgType: imgType
        }
        // 如何是礼物的话需要先弹框
        if (item.children[index].outType === 1) {
          setTimeout(() => {
            this.showSendGift = true
          }, 500)
          return
        }
        // 调用领取接口
        this.doGet()
      }
    },
    doGet () {
      if (!this.waitSendObj) {
        return
      }
      if (this.isRequesting) {
        return
      }
      this.isRequesting = true
      // 掉接口获取权益/礼物
      const reqData = {
        outType: this.waitSendObj.outType,
        propId: this.waitSendObj.propId,
        propType: this.waitSendObj.propType,
        rewardNumber: this.waitSendObj.rewardNumber || null,
        hours: this.waitSendObj.hours || null
      }
      apiFriendshipGetAndSend(this.targetUid, this.waitSendObj.grade, reqData).then(res => {
        if (res) {
          this.$client.showToast(this.$t('lang.wd.state3'))
          this.waitSendObj = null
          this.showSendGift = false
          this.fatchIntimacyDiary(false)
        }
      }).finally(() => {
        this.isRequesting = false
      })
    },
    handleSend () {
      this.doGet()
    },
    handleLater () {
      this.showSendGift = false
    },
    handleLevelOk () {
      this.showNewfriendship = false
    },
    handleGuideOk () {
      this.guideShow = false
      setTimeout(() => {
        this.laterShowNewfriendship = false
      }, 500)
    }
  }
}